import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { AccessorialInventoryRoutingModule } from '@ruby/modules/accessorial-inventory/accessorial-inventory-routing.module';
import { AccessorialInventoryComponent } from '@ruby/modules/accessorial-inventory/components/accessorial-inventory.component';
import { LeaseTrackOverageComponent } from '@ruby/modules/accessorial-inventory/components/lease-track-overage/lease-track-overage.component';
import { MonitorDateActionComponent } from '@ruby/modules/accessorial-inventory/components/monitor-date-action/monitor-date-action.component';
import { AccessorialInventoryContainer } from '@ruby/modules/accessorial-inventory/containers/accessorial-inventory.container';
import { LeaseTrackOverageContainer } from '@ruby/modules/accessorial-inventory/containers/lease-track-overage/lease-track-overage.container';
import { MonitorDateActionContainer } from '@ruby/modules/accessorial-inventory/containers/monitor-date-action/monitor-date-action.container';
import { AccessorialInventoryEffects, fromAccessorialInventory } from '@ruby/modules/accessorial-inventory/store';
import { MonitorDateDialogModule } from '@ruby/shared/dialogs/inventory-management/monitor-date/monitor-date.module';
import { ChargeColumnModule } from '@ruby/shared/inventory-management/charge-column/charge-column.module';
import { HeaderSummaryModule } from '@ruby/shared/inventory-management/header-summary/header-summary.module';
import { PipesModule } from '@ruby/shared/pipes/pipes.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    AccessorialInventoryContainer,
    AccessorialInventoryComponent,
    LeaseTrackOverageComponent,
    LeaseTrackOverageContainer,
    MonitorDateActionComponent,
    MonitorDateActionContainer
  ],
  imports: [
    AccessorialInventoryRoutingModule,
    CommonModule,
    ChargeColumnModule,
    EffectsModule.forFeature([AccessorialInventoryEffects]),
    HeaderSummaryModule,
    MatButtonModule,
    MonitorDateDialogModule,
    MatTabsModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    PipesModule,
    StoreModule.forFeature(fromAccessorialInventory.featureKey, fromAccessorialInventory.reducer)
  ],
  exports: [AccessorialInventoryContainer]
})
export class AccessorialInventoryModule {}
